import { Component } from 'react';

export default class RefHolder extends Component<any, any> {
    render() {
        return this.props.children;
    }
}
